import { defineNuxtPlugin } from '#app/nuxt'
import { LazyQtmAddress, LazyQtmAutocomplete, LazyQtmBadge, LazyQtmBtn, LazyQtmCheckbox, LazyQtmChip, LazyQtmCombobox, LazyQtmContentBlock, LazyQtmDataTable, LazyQtmDialogCard, LazyQtmIconBtn, LazyQtmInputLabel, LazyQtmLink, LazyQtmMenuSelectWrapper, LazyQtmMenuSelect, LazyQtmMultiMenuSelect, LazyQtmNumberField, LazyQtmPagination, LazyQtmPasswordField, LazyQtmPhoneNumber, LazyQtmRadioGroup, LazyQtmRadio, LazyQtmSelect, LazyQtmSkeleton, LazyQtmTextField, LazyQtmTextarea, LazySafeHtml } from '#components'
const lazyGlobalComponents = [
  ["QtmAddress", LazyQtmAddress],
["QtmAutocomplete", LazyQtmAutocomplete],
["QtmBadge", LazyQtmBadge],
["QtmBtn", LazyQtmBtn],
["QtmCheckbox", LazyQtmCheckbox],
["QtmChip", LazyQtmChip],
["QtmCombobox", LazyQtmCombobox],
["QtmContentBlock", LazyQtmContentBlock],
["QtmDataTable", LazyQtmDataTable],
["QtmDialogCard", LazyQtmDialogCard],
["QtmIconBtn", LazyQtmIconBtn],
["QtmInputLabel", LazyQtmInputLabel],
["QtmLink", LazyQtmLink],
["QtmMenuSelectWrapper", LazyQtmMenuSelectWrapper],
["QtmMenuSelect", LazyQtmMenuSelect],
["QtmMultiMenuSelect", LazyQtmMultiMenuSelect],
["QtmNumberField", LazyQtmNumberField],
["QtmPagination", LazyQtmPagination],
["QtmPasswordField", LazyQtmPasswordField],
["QtmPhoneNumber", LazyQtmPhoneNumber],
["QtmRadioGroup", LazyQtmRadioGroup],
["QtmRadio", LazyQtmRadio],
["QtmSelect", LazyQtmSelect],
["QtmSkeleton", LazyQtmSkeleton],
["QtmTextField", LazyQtmTextField],
["QtmTextarea", LazyQtmTextarea],
["SafeHtml", LazySafeHtml],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
